/**
 * Portfolio page data for /heli.
 * - Add Heli's photo as public/heli-portfolio.png (or .jpg).
 * - Set linkedInUrl to Heli's LinkedIn profile.
 * - Brands: add logos to public/heli-brands/ as .svg, .png, or .jpg. Remove the background
 *   so only the logo shows (transparent for SVG/PNG; or background-removed JPG/PNG).
 *   Set socialUrl for the link when the logo is clicked (e.g. Instagram page).
 * - Add gallery images to public/haleys-gallery/ (e.g. 1.jpg, 2.jpg) and list filenames below.
 */

export const HELI_PHOTO = process.env.PUBLIC_URL + '/heli-portfolio.png';
export const HELI_LINKEDIN_URL = 'https://www.instagram.com/_misthel/';

/** Logo filename in public/heli-brands/ (.svg, .png, or .jpg). Use logos with background removed. socialUrl = link when clicked. */
export const BRANDS = [
  { name: 'Bungalow', logo: 'Bungalow.jpeg', socialUrl: 'https://www.instagram.com/bungalowny/' },
  { name: 'GupShup', logo: 'gupshup.jpeg', socialUrl: 'https://www.instagram.com/gupshupnyc/' },
  { name: 'Chote Miya', logo: 'Chote Miya.jpeg', socialUrl: 'https://www.instagram.com/chotenyc/' },
  { name: 'Ammi', logo: 'Ammi.jpeg', socialUrl: 'https://www.instagram.com/amminyc/' },
  { name: 'Skewr', logo: 'skewr.jpeg', socialUrl: 'https://www.instagram.com/skewrnyc/' },
  { name: 'Brewr', logo: 'Brewr.jpeg', socialUrl: 'https://www.instagram.com/brewrnyc/' },
  { name: 'Mithailwala', logo: 'mithaiwaala.jpeg', socialUrl: 'https://www.instagram.com/mithaiwala.nyc/' },
  { name: 'Horseshoe Kitchen', logo: 'horseshoe.jpeg', socialUrl: 'https://www.instagram.com/thehorseshoejc/' },
  { name: 'BrewShot', logo: 'BrewShot.jpeg', socialUrl: 'https://www.instagram.com/brewshotjc/' },
];

export const BRANDS_LOGO_BASE = process.env.PUBLIC_URL + '/heli-brands/';

/** Gallery image filenames in public/haleys-gallery/ (e.g. ['1.jpeg', '2.jpeg']). Add your images there. */
export const GALLERY_IMAGES = ['1.jpeg', '2.jpeg', '3.jpeg', '4.jpeg', '5.jpeg', '6.jpeg', '7.jpeg', '8.jpeg', '9.jpeg', '10.jpeg', '11.jpeg', '12.jpeg', '13.jpeg', '14.jpeg', '15.jpeg', '16.jpeg', '17.jpeg', '18.jpeg', '19.jpeg', '20.jpeg', '21.jpeg', '22.jpeg', '23.jpeg', '24.jpeg', '25.jpeg', '26.jpeg', '27.jpeg', '28.jpeg', '29.jpeg', '30.jpeg', '31.jpeg', '32.jpeg'];
